<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <div class="row">
                <h5 class="card-title text-primary mx-auto">{{ localizationStore.translate('lob.settings') }}</h5>
            </div>
            <div class="row">
    
                <a href="https://dashboard.lob.com/#/register" target="_blank" class="btn-sm btn-primary mx-auto mb-1">
                    <i data-feather="external-link"></i> <span>Lob Certified Mail Sign-Up</span>
                </a>
            </div>
            <!-- action="{{ route('lob_settings_update') }}" -->
            <form>
                <div class="row mx-auto">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="lastname">{{ localizationStore.translate('lob.api.key') }}</label>
                                <input type="text" class="form-control" required :placeholder="localizationStore.translate('lob.api.key.placeholder')" id="lob_key"
                                    name="lob_key" v-model="lob_key">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="live_lob_key">
                                    {{ localizationStore.translate('live.lob.api.key') }}
                                </label>
                                <input
                                    type="text"
                                    required
                                    class="form-control"
                                    :placeholder="localizationStore.translate('lob.api.key.placeholder')"
                                    id="live_lob_key"
                                    name="live_lob_key"
                                    v-model="live_lob_key"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                        <label class="label-green" for="mode">{{ localizationStore.translate('lob.mode') }}</label>
                        <div class="demo-inline-spacing">
                            <div class="custom-control custom-radio mt-0">
                                <input
                                    type="radio"
                                    id="mode_off"
                                    required
                                    name="mode"
                                    class="custom-control-input"
                                    value="0"
                                    v-model="mode"
                                />
                                <label class="custom-control-label label-green" for="mode_off" @click="selectMode(0)">
                                    {{ localizationStore.translate('lob.api.service.test') }}
                                </label>
                            </div>
                            <div class="custom-control custom-radio mt-0">
                                <input
                                    type="radio"
                                    id="mode_on"
                                    required
                                    name="mode"
                                    class="custom-control-input"
                                    value="1"
                                    v-model="mode"
                                />
                                <label class="custom-control-label label-green" for="mode_on" @click="selectMode(1)">
                                    {{ localizationStore.translate('lob.api.service.live') }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <button type="button" class="btn btn-primary mr-2" @click="saveLob">{{ localizationStore.translate('save.changes') }}</button>
                        <button type="button" data-dismiss="modal" class="btn btn-outline-secondary">{{ localizationStore.translate('close') }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../../stores/LocalizationStore.js'
import axios from 'axios'
export default{
    components:{

    },
    setup() {
        return {
            lob_key: ref(),
            live_lob_key: ref(),
            mode: ref(),
            userStore : useUserStore(),
            businessStore : useBusinessStore(),
            localizationStore : useLocalizationStore(),
        }
    },
    watch: {
        async 'businessStore.business' (value) {
            this.lob_key = value.lobSettings ? value.lobSettings.lob_key : null
            this.live_lob_key = value.lobSettings ? value.lobSettings.live_lob_key : null
            this.mode = value.lobSettings ? value.lobSettings.mode : null
        },
    },
    methods:{
        saveLob(){
            const data= {
                lob_key:this.lob_key,
                live_lob_key:this.live_lob_key,
                mode:this.mode
            }
            const route = this.$router.resolve(
                {
                    name: 'lob-settings',
                }
            );
            axios.put(route.href,data).then(({data})=>{
                if(data.error == false){
                    toastr.success(data.message,'Success')
                }else{
                    toastr.success(data.message,'Error')
                }
            })
        },
        selectMode(val){
            this.mode = val
        }
    }
}
</script>